type PrimaryValue<T> = T & { isPrimary: boolean }

export function getPrimary<T>(a: PrimaryValue<T>[]): PrimaryValue<T> {
  const value = a.find((x) => x.isPrimary)
  if (value) {
    return value
  }
  return a[0]
}
